import { motion } from "framer-motion";
import { Box } from "@mui/material";
import "react-circular-progressbar/dist/styles.css";
import { useMediaQuery } from "@mui/system";
import VinylSVG from "./VinylSVG";
const Preloader = ({ loadingPercent, isMain }) => {
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <Box
      display={"flex"}
      justifyContent="center"
      flexDirection={"column"}
      alignItems={"center"}
      height={isMobile ? "100vh" : "100vh"}
      width={"100%"}
      backgroundColor="#000"
      zIndex={100000}
      left={0}
      py={3} // py-24 in Tailwind è equivalente a py={6} in MUI per una distanza simile
    >
      {isMain ? null : <BarLoader />}
      {isMain ? (
        <div
          style={{
            width: isMobile ? 75 : 90,
            height: isMobile ? 75 : 90,
            position: "absolute",
            bottom: "45vh",
          }}
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8, ease: "easeInOut" }} // Durata fade
          >
            <VinylSVG loadingPercent={loadingPercent} />
          </motion.div>
        </div>
      ) : null}
    </Box>
  );
};

const variants = {
  initial: {
    scaleY: 0.5,
    opacity: 0,
  },
  animate: {
    scaleY: 1,
    opacity: 1,
    transition: {
      repeat: Infinity,
      repeatType: "mirror",
      duration: 1,
      ease: "circIn",
    },
  },
};

const BarLoader = () => {
  return (
    <motion.div
      transition={{
        staggerChildren: 0.25,
      }}
      initial="initial"
      animate="animate"
      style={{
        display: "flex",
        gap: "8px", // gap-1 in Tailwind è equivalente a 8px in MUI
      }}
    >
      <motion.div
        variants={variants}
        style={{ height: "48px", width: "8px", backgroundColor: "white" }}
      />
      <motion.div
        variants={variants}
        style={{ height: "48px", width: "8px", backgroundColor: "white" }}
      />
      <motion.div
        variants={variants}
        style={{ height: "48px", width: "8px", backgroundColor: "white" }}
      />
      <motion.div
        variants={variants}
        style={{ height: "48px", width: "8px", backgroundColor: "white" }}
      />
      <motion.div
        variants={variants}
        style={{ height: "48px", width: "8px", backgroundColor: "white" }}
      />
    </motion.div>
  );
};

export default Preloader;
